import React from 'react';

const ArrowForSelect: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.5">
                <path d="M3.96973 6.02979L7.96999 10.0301" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
                <path d="M12.0288 6.02983L8.03063 10.0289" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
            </g>
        </svg>
    );
};

export default ArrowForSelect;